module.exports = __webpack_public_path__ + "components/country-flag/static/ca-535d191e790f1c684df688bd17f51859.svg";